import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let subscriber = useDataValue({
    context: 'subscriber',
    viewPath: props.viewPath,
  })

  return function onSubmit(value) {
    submit({ type: 'update-stages', stages: value, subscriber })
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
